<div *ngIf="!hideCard" class="card mb-md mr-md">
  <ng-container [ngSwitch]="displayType">
    <bw-card-legacy
      *ngSwitchCase="displayTypes.ACTIVE_DEFAULT"
      cardType="promo"
      [cardTextColor]="card.closeable ? 'var(--primary-text)' : 'var(--blue-70)'"
      [title]="card.title | translate"
      [bgImageSrc]="card.graphic"
      [closeable]="card.closeable"
      (closeCard)="completeCardHandler()"
    >
      <bw-card-body-legacy>{{ card.subText | translate }}</bw-card-body-legacy>
      <bw-card-footer-legacy>
        <button *ngIf="card.cta && card.closeable" bw-outlined-button-legacy (click)="ctaHandler($event)">{{ card.cta | translate }}</button>
        <button
          *ngIf="card.cta && !card.closeable"
          bw-button-legacy
          [processing]="card.processing"
          (click)="ctaHandler($event); card.processing = true;">
          {{ card.cta | translate }}
        </button>
      </bw-card-footer-legacy>
    </bw-card-legacy>

    <bw-card-legacy
      *ngSwitchCase="displayTypes.ACTIVE"
      cardType="active-product"
      [title]="card.title | translate" (cardAction)="ctaHandler($event)">
      <bw-card-header-legacy>
        <ng-container *ngFor="let segment of infoSegments">
          <div class="flex-row pointer" (click)="bannerHandler($event)">
            <typography-legacy text-small-regular class="disabled-text mr-xs">{{ segment.title | translate }}</typography-legacy>
            <!-- the icon is not stored in the segment anywhere so we will presume to show it when the cta is for a modal -->
            <bw-icon-legacy
              *ngIf="segment.ctaPath && segment.ctaPath.includes('modal:')"
              size="16"
              iconName="information"
              color="var(--disabled-text)"
            ></bw-icon-legacy>
          </div>
        </ng-container>
      </bw-card-header-legacy>
      <bw-card-body-legacy>
        <div class="flex-row space-between pointer">
          <ng-container *ngFor="let segment of defaultSegments">
            <div class="flex-row">
              <bw-icon-legacy [iconName]="segment.icon" horizontalSpace="mr-sm" color="var(--brand)"></bw-icon-legacy>
              <typography-legacy text-large-regular>{{ segment.title | translate }}</typography-legacy>
            </div>
            <typography-legacy *ngIf="segment.type === 'Cta'; else dynamicValueDisplay" text-large-semibold>
              <a bw-anchor-legacy [routerLink]="segment.ctaPath" class="bs-blue brand pr-xl">View</a>
            </typography-legacy>

            <ng-template #dynamicValueDisplay>
              <typography-legacy text-large-regular>{{ segment.dynamicValue | translate }}</typography-legacy>
            </ng-template>
          </ng-container>
        </div>
        <div class="flex-row space-between pointer">
          <ng-container *ngFor="let segment of ctaSegments">
            <div class="flex-row">
              <bw-icon-legacy
                size="32"
                [iconName]="segment.icon"
                horizontalSpace="mr-sm"
                color="var(--brand)"
                backgroundColor="var(--bg-gray)"
              ></bw-icon-legacy>
              <div class="flex-column">
              <typography-legacy text-small-semibold color="var(--brand)">{{ segment.title | translate }}</typography-legacy>
                <typography-legacy text-small-regular>{{ segment.subText | translate }}</typography-legacy>
              </div>
            </div>
          </ng-container>
        </div>
      </bw-card-body-legacy>
      <bw-card-banner-legacy [cardBannerColor]="cardBannerColor" *ngIf="errorFooter" (click)="errorStateClickHandler($event)">
        <div class="flex-row" [ngClass]="{'pointer': errorFooter.ctaPath}">
          <div class="flex-row">
            <bw-icon-legacy iconName="alert" size='16' color="var(--red-50)" horizontalSpace="mr-xs"></bw-icon-legacy>
            <typography-legacy text-small-regular class="primary-text">{{ errorFooter.title | translate }}</typography-legacy>
          </div>
        </div>
      </bw-card-banner-legacy>
    </bw-card-legacy>

    <bw-card-legacy *ngSwitchCase="displayTypes.ACTIVE_LOCKED" cardType="info" [title]="card.title | translate" (click)="clickHandler()">
      <bw-card-body-legacy>
        <div class="flex-row">
          <bw-icon-legacy iconName="lock" horizontalSpace="mr-sm"></bw-icon-legacy
          ><typography-legacy class="disabled-text">{{ 'ONLY_ON_MOBILE' | translate }}</typography-legacy>
        </div>
      </bw-card-body-legacy>
    </bw-card-legacy>

    <bw-card-legacy cardType="action" *ngSwitchDefault [title]="(card.titleKey ?? card.title) | translate" (cardAction)="clickHandler()">
      <bw-card-body-legacy>{{ (card.textKey ?? card.text) | translate }}</bw-card-body-legacy>
<!--      <bw-card-body-legacy>{{ !card.textKey ? (card.text | translate) : card.textKey | translate }}</bw-card-body-legacy>-->
    </bw-card-legacy>
  </ng-container>
</div>

<bw-modal-legacy
  *ngIf="displayType === displayTypes.ACTIVE_DEFAULT && showVideoModal"
  [showCloseButton]="true"
  modalWidth="large"
  (closeModal)="showVideoModal = false"
>
  <bw-video-legacy
    [title]="card.title | translate"
    [cdnBase]="cdnBase"
    [path]="card.ctaPath"
  ></bw-video-legacy>
</bw-modal-legacy>
<brightside-web-generic-modal
  *ngIf="bannerModalVisible"
  [model]="modalModel"
  fbPage="home"
  fbCategory="home"
  fbAction="view_card_banner_modal"
  (primaryClick)="bannerModalVisible = false"
  (secondaryClick)="bannerModalVisible = false"
></brightside-web-generic-modal>
